/*
 * Cookie preferences link
 *
 * Reopens the consent preferences dialog of whichever consent tool is active
 * on the storefront. The link stays hidden until a tool is detected, so it
 * never renders as a dead control while no banner is installed.
 *
 * Supported out of the box: Shopify's native cookie banner, Usercentrics,
 * Cookiebot, and Consentmanager. Anything else can register itself by
 * assigning a function to window.cookiePreferencesHandler.
 */
(function () {
  var PROVIDERS = [
    {
      name: 'shopify',
      available: function () {
        return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
      },
      open: function () {
        window.privacyBanner.showPreferences();
      },
    },
    {
      name: 'usercentrics',
      available: function () {
        return window.UC_UI && typeof window.UC_UI.showSecondLayer === 'function';
      },
      open: function () {
        window.UC_UI.showSecondLayer();
      },
    },
    {
      name: 'cookiebot',
      available: function () {
        return window.Cookiebot && typeof window.Cookiebot.renew === 'function';
      },
      open: function () {
        window.Cookiebot.renew();
      },
    },
    {
      name: 'consentmanager',
      available: function () {
        return window.__cmp && typeof window.__cmp === 'function';
      },
      open: function () {
        window.__cmp('displayConsentUi');
      },
    },
    {
      name: 'custom',
      available: function () {
        return typeof window.cookiePreferencesHandler === 'function';
      },
      open: function () {
        window.cookiePreferencesHandler();
      },
    },
  ];

  // Consent scripts load asynchronously and often late, so keep looking for a
  // while rather than deciding once on page load.
  var POLL_INTERVAL = 400;
  var POLL_TIMEOUT = 15000;

  function findProvider() {
    for (var i = 0; i < PROVIDERS.length; i++) {
      try {
        if (PROVIDERS[i].available()) return PROVIDERS[i];
      } catch (error) {
        // A provider that throws while being probed is treated as absent.
      }
    }
    return null;
  }

  function reveal(element, provider) {
    element.hidden = false;
    element.setAttribute('data-cookie-provider', provider.name);
  }

  function init(element) {
    if (element.dataset.cookiePreferencesReady === 'true') return;
    element.dataset.cookiePreferencesReady = 'true';

    var alwaysShow = element.dataset.alwaysShow === 'true';
    if (alwaysShow) element.hidden = false;

    element.addEventListener('click', function (event) {
      event.preventDefault();
      var provider = findProvider();
      if (!provider) {
        console.warn('[cookie-preferences] No consent management tool detected on this page.');
        return;
      }
      try {
        provider.open();
      } catch (error) {
        console.warn('[cookie-preferences] Could not open the preferences dialog.', error);
      }
    });

    var provider = findProvider();
    if (provider) {
      reveal(element, provider);
      return;
    }

    var elapsed = 0;
    var timer = setInterval(function () {
      elapsed += POLL_INTERVAL;
      var found = findProvider();
      if (found) {
        reveal(element, found);
        clearInterval(timer);
      } else if (elapsed >= POLL_TIMEOUT) {
        clearInterval(timer);
      }
    }, POLL_INTERVAL);
  }

  function initAll() {
    var elements = document.querySelectorAll('[data-cookie-preferences]');
    for (var i = 0; i < elements.length; i++) init(elements[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
